import { z } from 'zod';

const PermissionSchema = z
  .object({
    permission: z.object({
      name: z.string(),
    }),
  })
  .transform(raw => raw.permission.name);

const RoleSchema = z.object({
  id: z.string(),
  role: z.string(),
  app: z.string(),
  permissions: z.array(PermissionSchema),
});

// ── Response (API shape → transform to DTO) ─────────────
const AdminResultSchema = z
  .object({
    id_admin: z.string(),
    admin_name: z.string(),
    admin_email: z.string(),
    role_id: z.string().nullable(),
    is_verified: z.boolean(),
    created_at: z.string(),
    updated_at: z.string(),
    role: RoleSchema.nullable().optional(),
    permissions: z.array(z.string()),
  })
  .transform(raw => ({
    idAdmin: raw.id_admin,
    adminName: raw.admin_name,
    adminEmail: raw.admin_email,
    roleId: raw.role_id,
    isVerified: raw.is_verified,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
    role: raw.role ?? null,
    permissions: raw.permissions ?? [],
  }));

const AdminApiSchema = z
  .object({
    result: AdminResultSchema,
  })
  .transform(raw => raw.result);

// Inferred DTO type (camelCase — what your UI uses)
export type MeDTO = z.infer<typeof AdminApiSchema>;

export function toMeDTO(raw: unknown): MeDTO {
  return AdminApiSchema.parse(raw);
}
